<div style="min-height: 100vh" class="flex flex-col justify-between">
  <div>
    <app-header />
    <ng-content />
  </div>
  <app-footer />
</div>
